// The pages a deal's or a contact's side sheet opens over (TF-385): the CRM's pages (the calendar among
// them) and the dashboard. Elsewhere ?deal=<id> and ?contact=<id> mean something of the page's own -
// on the files page, the list's filter (FileFilters) - and open no sheet: a modal sheet there hid the
// preview and the editor opened from the files.

const PAGES = /^\/c\/[^/]+(?:\/?|\/crm(?:\/.*)?)$/;

export function opensQuickViews(pathname: string): boolean {
  return PAGES.test(pathname);
}
